import PropTypes from 'prop-types';
import React from 'react';
import './ModalHeaderWithActions.css';

const ModalHeaderWithActions = ({
  onCancel,
  onSend,
  title,
  cancelText,
  sendText,
}) => (
  <div className="ModalHeaderWithActions">
    <div className="ModalHeaderWithActions__Action">
      <a onClick={onCancel}>{cancelText}</a>
    </div>
    <div className="ModalHeaderWithActions__Title">{title}</div>
    <div className="ModalHeaderWithActions__Action">
      <a onClick={onSend}>{sendText}</a>
    </div>
  </div>
);

ModalHeaderWithActions.propTypes = {
  title: PropTypes.node.isRequired,
  onCancel: PropTypes.func.isRequired,
  cancelText: PropTypes.node.isRequired,
  onSend: PropTypes.func.isRequired,
  sendText: PropTypes.node.isRequired,
};

export default ModalHeaderWithActions;
